import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {CONSTANTS} from 'src/app/constants';
import {AuthService} from 'src/app/providers/services/auth.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LoginComponent implements OnInit {

    infoMessage = '';
    returnUrl = '';

    constructor(
        private authService: AuthService,
        private router: Router,
        private _route: ActivatedRoute,
    ) { }

    async ngOnInit(): Promise<void> {
      this.returnUrl = this._route.snapshot.queryParams['returnUrl'] || CONSTANTS.ROUTES.HOME;
      await this.authService.login();

        // Navigate for authenticated user
        if (await this.authService.isAuthenticated()) {
            await this.router.navigateByUrl(this.authService.consumeReturnUrl() || this.returnUrl);
        }
    }

    async login(): Promise<void> {
        window.location.assign(CONSTANTS.AUTH.LOGIN_URL);
    }
}
